import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ChangePasswordModel(Model) {
    var self = this;
    ko.map.fromJS(Model, self);
    self.CaptionUsername = ko.observable();
    self.CaptionOldPassword = ko.observable();
    self.CaptionNewPassword = ko.observable();
    self.CaptionNewPassword2 = ko.observable();
    self.MessageMandatoryFields = ko.observable();
    self.MessagePasswordNotMatching = ko.observable();
    self.SecurityPolicyDescription = ko.observable();
    var captionDeferred = Bao.Session.GetCaptions("ChangePasswordDialog", self.LanguageSymbol()).then(function (captions) {
        self.CaptionUsername(captions.lblUsername);
        self.CaptionOldPassword(captions.lblOldPassword);
        self.CaptionNewPassword(captions.lblNewPassword);
        self.CaptionNewPassword2(captions.lblNewPassword2);
        self.MessageMandatoryFields(captions.msgFillMandatoryFields);
        self.MessagePasswordNotMatching(captions.msgPasswordNotMatching);
    });
    Bao.post("Login/GetSecurityPolicy", function (securityPolicyDescription) {
        self.SecurityPolicyDescription(securityPolicyDescription);
    });
    self.CompleteCheck = function () {
        var isComplete = true;
        var _message = self.MessageMandatoryFields();
        if (Bao.Utils.String.IsNullOrEmpty(self.OldPassword())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.NewPassword())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.NewPassword2())) {
            isComplete = false;
        }
        if (self.NewPassword2() != self.NewPassword()) {
            isComplete = false;
            _message = self.MessagePasswordNotMatching();
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, _message, "info");
        }
        return isComplete;
    };
    self.init = function () {
        return Bao.post("Login/GetSecurityPolicy", function (securityPolicyDescription) {
            self.SecurityPolicyDescription(securityPolicyDescription);
        });
    };
}
export default ChangePasswordModel;